// extracted by mini-css-extract-plugin
module.exports = {"honest-icon":"a10a3f92e9--honest-icon--snXSr"};